import { LoadingScreen } from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import { Backdrop, Paper } from '@mui/material';
import { lazy, memo } from 'react';
import { useBrowseMoreFilters } from '../more-filters/hooks/use-browse-more-filters';
import { SearchFilterProvider } from './context';
import * as SX from './sx';
import type { SearchFiltersProps as Props } from './types';

const FilterList = lazy(() =>
  import(/* vitePreload: true */ './components/filter-list/filter-list').then(
    (m) => ({
      default: m.FilterList,
    })
  )
);

export const SearchFilters = memo(({ className }: Props) => {
  const api = useBrowseMoreFilters();

  return (
    <SearchFilterProvider>
      <Paper className={classnames('SearchFilters', className)}>
        <FilterList />
        <Backdrop
          className="FiltersBackdrop"
          sx={SX.backdropSx}
          open={api.isLoading}
        >
          <LoadingScreen />
        </Backdrop>
      </Paper>
    </SearchFilterProvider>
  );
});

SearchFilters.displayName = 'SearchFilters';
